/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import CopyToClipboard from "react-copy-to-clipboard";
import { Box, FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import { showInfo } from "~/services/toast";

type Props = {
  children: string;
};

export function CopyBox({ children }: Props) {
  return (
    <Box
      boxStyle="grey"
      marginBottom={theme.spacing.spacing01}
      padding={theme.spacing.spacing02}
    >
      <FlexContainer justifyContent="space-between">
        {children}
        <CopyToClipboard
          text={children}
          css={{
            cursor: "pointer",
          }}
          onCopy={() => showInfo("Command copied to clipboard")}
        >
          <SVGIcon name="copy" />
        </CopyToClipboard>
      </FlexContainer>
    </Box>
  );
}
